<template>
  <div class="user-infor-card">
    <div class="userinfo d-flex py-3" :class="{noborder:type=='small'}">
      <!-- avatar img start-->
      <div :class="{'user-infor-card-avatar':type=='default','small':type=='small'}">
        <a  v-if="$store.state.user.check_is_wxc_domain() || $store.state.user.check_is_wxcblog_domain()"
            :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
          <div style="position:relative">
            <icon-V class="text-primary lable" v-if="curent_data.userinfo_userID.is_hot_blogger"></icon-V>
          </div>
          <div v-if="!curent_data.userinfo_userID.avatar" class="avatar-word">
            {{ curent_data.userinfo_userID.first_letter }}
          </div>
          <img style="min-width: 60px;height: 60px"
               v-if="curent_data.userinfo_userID.avatar"
               v-bind:alt="curent_data.userinfo_userID.username"
               class="rounded-circle shadow-sm border"
               v-bind:src="curent_data.userinfo_userID.avatar"
          >
        </a>
        <router-link
            v-else
            :to="'/userindex/'+curent_data.userID">
          <div style="position:relative">
            <icon-V class="text-primary lable" v-if="curent_data.userinfo_userID.is_hot_blogger"></icon-V>
          </div>
          <div v-if="!curent_data.userinfo_userID.avatar" class="avatar-word">
            {{ curent_data.userinfo_userID.first_letter }}
          </div>
          <img style="min-width: 60px;height: 60px"
               v-if="curent_data.userinfo_userID.avatar"
               v-bind:alt="curent_data.userinfo_userID.username"
               class="rounded-circle shadow-sm border"
               v-bind:src="curent_data.userinfo_userID.avatar"
          >
        </router-link>
      </div>
      <!-- title start-->
      <div class='align-self-center right pl-2 flex-grow-1 ml-4'>
        <div class="d-flex align-self-center justify-content-between">
          <div :class="{'blogger-name':type=='default','small-name':type=='small'}">
            <a  v-if="$store.state.user.check_is_wxc_domain() || $store.state.user.check_is_wxcblog_domain()"
                :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
              <span v-if="usertype!=='search'">{{ curent_data.userinfo_userID.username }}</span>
            </a>
            <router-link
                v-else
                :to="'/userindex/'+curent_data.userID" style="font-size: 20px;font-weight: normal">
              <span v-if="usertype!=='search'">{{ curent_data.userinfo_userID.username }}</span>
              <span v-if="usertype==='search'" class="text-muted">
                        <span v-html="curent_data.username" style="color:#14171a;"></span>
                        <span style="font-size:24px;font-weight:200;padding:0 14px">|</span>博客名：<span
                  v-html="curent_data.name"></span>
                      </span>
            </router-link>
            <el-tooltip effect="light" :content="getCountryName()" placement="top" visible-arrow="false">
              <a style="font-size:19px;margin-left:5px;text-decoration: none;cursor: pointer">{{
                  curent_data.userinfo_userID.country_flag.flag
                }}</a>
            </el-tooltip>
          </div>

        </div>
        <div class="description" :title="curent_data.userinfo_userID.description">
          {{ curent_data.userinfo_userID.description }}
        </div>
      </div>
    </div>
    <div class="row">
      <!-- follow start-->
      <div class="col float-left follow mt-2"
           v-if="!$store.state.user.check_is_wxc_domain() && !$store.state.user.check_is_wxcblog_domain()">
        <a v-if="!curent_data.userinfo_userID.is_following" class="btn btn-link text-primary w-100 btn-follow"
           @click="following_add(curent_data.userID)">
          <div class="d-flex justify-content-center align-items-center add">
            <!--            <icon-plus></icon-plus>-->
            +
            {{ $t('message').blog.blogger_follow }}
          </div>
        </a>
        <a v-if="curent_data.userinfo_userID.is_following" class="btn btn-link text-default w-100 cancel-follow"
           @click="following_delete(curent_data.userID)">
                        <span class="cancel-text text-danger">
                            <div class="d-flex justify-content-center align-items-center">
                              <icon-x :style="{fill:'#FF3636'}"></icon-x>
                              {{ $t('message').blog.blogger_remove_follow }}
                            </div>
                        </span>
          <span class="followed-text text-default">
                            <div class="d-flex justify-content-center align-items-center" style="fill:#999">
                                <icon-check></icon-check>
                                {{ $t('message').blog.blogger_followed }}
                            </div>
                        </span>
        </a>
      </div>
      <!--  follow end-->
      <!--  qqh start-->
      <div class="col float-left qqh">
        <!--        <n-button-->
        <!--            v-if="!$store.state.user.check_is_wxc_domain() || !$store.state.user.check_is_wxcblog_domain()"-->
        <!--            link-->
        <!--            size="sm"-->

        <a style="margin-top: 12px" class="d-block"
           v-if="$store.state.user.check_is_wxc_domain() || $store.state.user.check_is_wxcblog_domain()"
           :href="'https://www.wenxuecity.com/qqh/index.php?act=write&cid='+curent_data.userinfo_userID.username">
          <icon-mail style="width:25px;fill:#39b8eb"></icon-mail>
          <span style="color:#39b8eb;font-size:1rem;">{{ $t('message').qqh.btn_send }}</span>
        </a>
        <!--        </n-button>-->
        <n-button
            v-else
            link
            size="sm"
            @click="openModal()"
            class="mt-2"
        >
          <icon-mail style="width:25px;fill:#39b8eb"></icon-mail>
          <span style="color:#39b8eb;font-size:1rem;">{{ $t('message').qqh.btn_send }}</span>
        </n-button>
      </div>
      <!-- Send QQH Modal -->
      <modal :show.sync="modals.sendQqhModal" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up" style="padding-top:5px">{{ $t('message').qqh.modal_title_prefix }}
          {{ curent_data.userinfo_userID.username }} {{ $t('message').qqh.modal_title }}</h4>

        <div class="datepicker-container d-flex justify-content-center">
          <el-input
              type="textarea"
              :rows="3"
              :placeholder="$t('message').qqh.modal_placeholder"
              v-model="modals.qqhMsgbody">
          </el-input>
        </div>

        <template slot="footer">
          <!--        <span v-if="modals.modalData"-->
          <!--              :class="{'text-success':modals.modalData.status,'text-danger':!modals.modalData.status,}">-->
          <!--          {{ modals.modalData.status ? $t('message').qqh.modal_succese : modals.modalData.error }}</span>-->
          <n-button
              class="mr-3"
              type="default"
              link
              @click.native="modals.sendQqhModal = false"
          >
            {{ $t('message').qqh.modal_btn_cancel }}
          </n-button>
          <n-button
              type="primary"
              round
              simple
              @click.native="sendQqh(data)"
          >
            {{ $t('message').qqh.modal_btn_send }}
          </n-button>
        </template>
      </modal>
      <login-dialog ref="dialog"></login-dialog>
    </div>
  </div>
</template>
<script>
import {
  // IconPlus,
  IconCheck,
  IconX,
  IconMail,
  IconV
} from '@/components/Icons';
import {
  Button,
  Modal,
} from '@/components';
import account from '@/module/user/user.service';
import LoginDialog from '@/module/user/login/LoginDialog';

export default {
  name: 'user-infor-card',
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type'
    },
    data: {
      userID: Number,
      count_follower: Number,
      count_buzz: Number,
      count_article: Number,
      count_comment: Number,
      count_read: Number,
      description: String,
      userinfo_userID: {
        id: Number,
        username: String,
        avatar: String,
        description: String,
        verified: Number,
        status: Number,
        first_letter: String,
        is_hot_blogger: Number,
        is_following: Number
      }
    },
    usertype: String
  },
  components: {
    [Button.name]: Button,
    // IconPlus,
    IconCheck,
    IconMail,
    IconX,
    IconV,
    Modal,
    LoginDialog
  },
  created: function () {
    let userinfor = this.$store.state.user.userinfo;
    this.loginuserID = userinfor ? userinfor.UserID : -1;
    if (this.usertype == "follower") {
      this.curent_data.userinfo_userID = this.data.userinfo_followerID;
      this.curent_data.userID = this.data.userinfo_followerID.id;
    }
  },
  methods: {
    following_add(id) {
      if (!this.check_user_login()) return;
      account.following_add(id).then(res => {
        if (res.status) {
          this.curent_data.userinfo_userID.is_following = 1;
        } else {
          this.$router.push({path: "/login", query: {redirect: this.$route.fullPath}})
        }
      });
    },
    getCountryName() {
      return localStorage.lang === 'cns' ? this.curent_data.userinfo_userID.country_flag.cns : this.curent_data.userinfo_userID.country_flag.cnt
    },
    following_delete(id) {
      if (!this.check_user_login()) return;
      account.following_delete(id).then(res => {
        if (res.data == true) {
          this.curent_data.userinfo_userID.is_following = 0;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    openModal() {
      if (this.$store.state.user.userinfo.UserID !== undefined) {
        this.modals.sendQqhModal = true
      } else {
        // this.$message.error(res.error);
        this.$router.push({path: "/login", query: {redirect: this.$route.fullPath}})
      }
    },
    sendQqh(data) {
      this.send(this.curent_data.userID, this.modals.qqhMsgbody);
    },
    async send(touserID, msgbody) {
      let user = this.$store.state.user;
      let res = await user.sendQqh(touserID, msgbody);

      this.modals.modalData = res

      setTimeout(() => {
        this.modals.modalData = undefined;
        this.modals.sendQqhModal = res.status ? false : true;
      }, 4);
      if (res.status) {
        this.$message.success("您的悄悄话已发送！");
      } else {
        this.$message.warning(res.error);
      }
    },
  },
  data() {
    return {
      loginuserID: -1,
      error: '',
      curent_data: this.data,
      modals: {
        sendQqhModal: false,
        qqhMsgbody: '',
        modalData: undefined
      },
    }
  },
  watch: {
    data(val) {
      this.curent_data = val
    }
  }
}

</script>
<style>
.right .btn .add {
  fill: #35abbb;
  font-size: 1rem;
}

user-infor-card {
  padding: 12px 18px;
  border-top: 1px solid #ebeef0;
}

user-infor-card.noborder {
  border-top: 0;
}

.user-infor-card .userinfo {
  border-bottom: 1px solid #f6f6f6;
}

user-infor-card a {
  color: #14171a;
  text-decoration: none;
}

user-infor-card a:hover {
  color: #235592
}

user-infor-card .description a {
  color: #657786
}

.user-infor-card-avatar .avatar-word, .hot-blogger.small .avatar-word {
  border-radius: 50%;
  background-color: #eeeeee;
  line-height: 48px;
  text-align: center;
  font-weight: 500;
  box-shadow: 0 3px 8px 0 rgb(0 0 0 / 17%);
}

.user-infor-card-avatar .avatar-word, .small .avatar-word:hover {
  background-color: #eeeeee;
}

.user-infor-card-avatar .avatar-word {
  min-width: 48px
}

.user-infor-card .small .lable {
  position: absolute;
  margin-left: 39px;
  margin-top: -14px;
  -webkit-transform: rotate(
      33deg);
  transform: rotate(
      35deg);
}

.user-infor-card-avatar .lable {
  position: absolute;
  margin-left: 28px;
  margin-top: -14px;
  transform: rotate(27deg)
}

.user-infor-card-avatar {
  width: 48px
}

.user-infor-card-avatar .rounded-circle, .user-infor-card-avatar .avatar-word:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}

.user-infor-card-avatar .small img {
  min-width: 60px;
  height: 60px;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
}

.user-infor-card .small .avatar-word {
  width: 60px;
  height: 60px;
  line-height: 60px;
  font-size: 1rem;
  color: #333;
}

.blogger-name {
  font-size: 1rem;
  font-weight: 600;

}

.blogger-name span {
  color: #333
}

.small-name {
  font-size: .95rem;
  font-weight: 600;

}

.user-infor-card span {
  color: black;
}

.cancel-follow span.cancel-text, .cancel-follow:hover span.followed-text {
  display: none;
}

.cancel-follow span.followed-text, .cancel-follow:hover span.cancel-text {
  display: block;
}

.cancel-follow, .btn-follow {
  padding: 0;
}

.user-infor-card .right a {
  padding: 0;
}

.user-infor-card .right .btn {
  margin: 0;
}

.user-infor-card .right .btn .add {
  fill: #35abbb;
  font-size: 1rem;
}

#WxcColor.user-infor-card .right .btn .add {
  fill: #44753d;
}

.user-infor-card .right .btn:hover .add {
  fill: #236e85;
}

.user-infor-card .right .description {
  font-size: medium;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: 4px;
}

.el-popover.bubble {
  background-color: #14171a;
  color: white
}

.el-popover.bubble .popper__arrow,
.el-popover.bubble .popper__arrow::after {
  border-top-color: #14171a;
  border-bottom-color: #14171a;
}

.el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after {
  display: none;
}

.el-tooltip__popper, .tooltip-inner {
  min-width: 32px !important;
}

@media (max-width: 575.98px) {
  .list-itme .list-itme-image {
    margin: auto 0;
    margin-left: .5rem;
  }

  .imgspace {
    width: 90px;
    height: 90px;
  }

  .user-infor-card {
    padding: 12px 0;
  }

  .user-infor-card .right .description {
    display: none;
  }

  .cancel-follow span.cancel-text.text-danger {
    display: block;
    color: #888 !important;
  }

  .cancel-follow span.followed-text {
    display: none;
  }
}
</style>